    <template>
        <div class="contentOuter">
            <div class="col-12">
                <form id="banks_form"
                      ref="banks_form" class="content-inner formValidation">
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <i class="fa fa-users"></i><span>{{lang('banks')}}</span>
                            <np-buttons
                                    class="pull-right"
                                    :buttons-config="[
                                {button_id: 'validate_and_save', icon: 'fa fa-check', type: 'save', lang_key: 'validate_and_save'},
                                {button_id: 'save', icon: 'fa fa-floppy-o', type: 'save', lang_key: 'save'},
                            ]"
                                    @buttonclick="submit"
                                    :small="true"
                            ></np-buttons>
                        </div>
                        <div class="panel-body">
                            <div class="row" ref="block_bank">
                                <div class="col-md-12" v-for="(bank, index) in banks">
                                    <div class="panel panel-default">
                                        <div class="panel-heading">
                                            <i class="fa fa-bank"></i><span>{{ lang(`${bank.bank_account_type.toLowerCase()}_bank`) }}</span>
                                        </div>
                                        <div class="panel-body">
                                            <div class="row">
                                                <div class="col-md-6 col-sm-6" ref="sub_block_bank_account">
                                                    <div class="panel-sub-heading headingSmall "><span
                                                            class="markedBottom">{{ lang('bank_account') }}</span></div>
                                                    <np-entry
                                                            :is-full="true"
                                                            ref="account_holder_name"
                                                            :label="lang('account_holder_name')"
                                                            :model-value="bank.account_holder_name">
                                                    </np-entry>
                                                    <div class="row">
                                                        <np-entry
                                                                ref="account_holder_name"
                                                                :label="lang('bank_sort_code')"
                                                                :model-value="bank.bank_sort_code">
                                                        </np-entry>
                                                        <np-entry
                                                                ref="bank_account_number"
                                                                :label="lang('account_number')"
                                                                :model-value="bank.bank_account_number">
                                                        </np-entry>
                                                    </div>
                                                    <div class="row">
                                                        <np-entry
                                                                ref="account_holder_name"
                                                                :label="lang('dda_number')"
                                                                :model-value="bank.dda_number">
                                                        </np-entry>
                                                        <np-entry
                                                                ref="routing_number"
                                                                :label="lang('routing_number')"
                                                                :model-value="bank.routing_number">
                                                        </np-entry>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 col-sm-6" ref="sub_block_bank_address">
                                                    <div class="panel-sub-heading headingSmall "><span
                                                            class="markedBottom">{{lang('bank_name_and_address')}}</span></div>
                                                    <div class="row">
                                                        <np-entry
                                                                ref="bank_name"
                                                                :label="lang('bank_name')"
                                                                :model-value="bank.bank_name">
                                                        </np-entry>
                                                    </div>
                                                    <div class="row">
                                                        <np-entry
                                                                :ref="`zip_code`"
                                                                :label="lang('zip_code')"
                                                                :model-value="bank.zip_code"
                                                        >
                                                        </np-entry>
                                                        <np-entry
                                                                ref="house_name"
                                                                :label="lang('house_name')"
                                                                :no-wrapper="false"
                                                                :required="false"
                                                                :model-value="bank.house_name">
                                                        </np-entry>
                                                        <np-entry
                                                                ref="house_number"
                                                                :label="lang('house_number')"
                                                                :model-value="bank.house_number">
                                                        </np-entry>
                                                        <np-entry
                                                                ref="street_line_1"
                                                                :label="lang('street_line_1')"
                                                                :model-value="bank.street_line_1">
                                                        </np-entry>
                                                        <np-entry
                                                                ref="bank_city"
                                                                :label="lang('city')"
                                                                :model-value="bank.bank_city">
                                                        </np-entry>
                                                        <np-entry
                                                                ref="county_code"
                                                                :label="lang('county_code')"
                                                                :model-value="bank.county_code">
                                                        </np-entry>
                                                        <np-entry
                                                                ref="bank_country_code"
                                                                :label="lang('country_code')"
                                                                :formatter="formatCountry"
                                                                :model-value="bank.country_code">
                                                        </np-entry>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </form>
            </div>
        </div>
    </template>

<script>
    import { NPEntry } from 'netpify/components';
    export default {

        name: "np-view-bank",
        components: { 'np-entry': NPEntry},
        description: "This component is used to display Bank Component on Merchant/Outlet Pages",
        data: function () {
            return {
            }
        },
        props: {
            bank: {
                type: Object,
                required: true
            },
        },
        computed: {
            title: function() {
                return 'Bank (' + this.bank.account_type + ')';
            }
        },
        methods: {
            formatCountry: function(data) {
                let vm = this;
                if(!!data) {
                    return this.formatSelectType(vm.parameters, data, 'COUNTRIES_PARAM');
                } else {
                    return '-';
                }
            },
        }
    }
</script>
